(function(){try{if(!document.body||!document.body.classList.contains('no-animations')){if(!window.matchMedia||!window.matchMedia('(prefers-reduced-motion: reduce)').matches){document.documentElement.classList.add('flame-anim');}}}catch(e){}})();
/* ==========================================================================
   Flamè — JavaScript del tema
   Vanilla JS, nessuna dipendenza. Ogni comportamento è un custom element
   o un piccolo modulo auto-inizializzante.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Utility
     ------------------------------------------------------------------------ */
  const Flame = (window.Flame = window.Flame || {});

  Flame.settings = window.flameSettings || {};
  Flame.routes = window.flameRoutes || {};
  Flame.strings = window.flameStrings || {};

  const debounce = (fn, wait = 300) => {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  const formatMoney = (cents) => {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, Flame.settings.moneyFormat);
    }
    const format = Flame.settings.moneyFormat || '€{{amount_with_comma_separator}}';
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  };

  Flame.formatMoney = formatMoney;

  const trapFocus = (container) => {
    const focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return () => {};
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const handler = (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    container.addEventListener('keydown', handler);
    window.setTimeout(() => first.focus(), 120);
    return () => container.removeEventListener('keydown', handler);
  };

  /* ------------------------------------------------------------------------
     Blocco scroll del body
     ------------------------------------------------------------------------ */
  let lockCount = 0;
  const lockScroll = () => {
    lockCount += 1;
    if (lockCount === 1) {
      const sbw = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = sbw > 0 ? `${sbw}px` : '';
      document.body.classList.add('is-locked');
    }
  };
  const unlockScroll = (force) => {
    lockCount = force ? 0 : Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      document.body.classList.remove('is-locked');
      document.body.style.paddingRight = '';
    }
  };

  /* ------------------------------------------------------------------------
     Drawer generico (menu, carrello, ricerca, filtri)
     ------------------------------------------------------------------------ */
  class FlameDrawer extends HTMLElement {
    constructor() {
      super();
      this.releaseFocus = () => {};
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.overlay = document.querySelector('[data-drawer-overlay]');
      this.querySelectorAll('[data-drawer-close]').forEach((btn) =>
        btn.addEventListener('click', () => this.close())
      );
    }

    open(opener) {
      this.opener = opener;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      if (this.overlay) this.overlay.classList.add('is-open');
      lockScroll();
      document.addEventListener('keydown', this.onKeydown);
      this.releaseFocus = trapFocus(this);
      this.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      if (this.overlay && !document.querySelector('flame-drawer.is-open')) {
        this.overlay.classList.remove('is-open');
      }
      unlockScroll();
      document.removeEventListener('keydown', this.onKeydown);
      this.releaseFocus();
      if (this.opener) this.opener.focus();
      this.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true }));
    }

    onKeydown(e) {
      if (e.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('flame-drawer')) customElements.define('flame-drawer', FlameDrawer);

  /* Dopo un'aggiunta al carrello: usa il drawer Flamē se presente,
     altrimenti quello di Horizon, altrimenti porta alla pagina carrello. */
  const flameOwnDrawer = () => document.querySelector('flame-drawer#cart-drawer');

  const afterAddToCart = (trigger) => {
    // Attenzione: anche Horizon ha un elemento con id "cart-drawer".
    // Apriamo il pannello solo se è davvero il nostro (tag flame-drawer),
    // altrimenti apriremmo quello del tema con dentro un carrello vecchio.
    if (flameOwnDrawer()) {
      openDrawer('cart-drawer', trigger);
      return;
    }
    window.location.href = (Flame.routes && Flame.routes.cart) || '/cart';
  };

  const openDrawer = (id, opener) => {
    const drawer = document.getElementById(id);
    if (drawer && typeof drawer.open === 'function') drawer.open(opener);
    return drawer;
  };
  Flame.openDrawer = openDrawer;

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-drawer-open]');
    if (trigger) {
      e.preventDefault();
      openDrawer(trigger.getAttribute('data-drawer-open'), trigger);
    }
    const overlay = e.target.closest('[data-drawer-overlay]');
    if (overlay) {
      document.querySelectorAll('flame-drawer.is-open').forEach((d) => d.close());
    }
  });

  /* ------------------------------------------------------------------------
     Header sticky / nascondi allo scroll
     ------------------------------------------------------------------------ */
  class FlameHeader extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.stickyMode || 'always';
      this.threshold = parseInt(this.dataset.threshold || '80', 10);
      this.lastY = window.scrollY;
      this.placeholder = null;
      this.onScroll = this.onScroll.bind(this);
      if (this.mode !== 'none') {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
      this.initMenus();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      const y = window.scrollY;
      const stuck = y > this.threshold;

      if (stuck && !this.classList.contains('is-stuck')) {
        this.height = this.offsetHeight;
        this.classList.add('is-stuck');
        if (!this.placeholder) {
          this.placeholder = document.createElement('div');
          this.placeholder.style.height = `${this.height}px`;
          this.parentNode.insertBefore(this.placeholder, this.nextSibling);
        }
      } else if (!stuck && this.classList.contains('is-stuck')) {
        this.classList.remove('is-stuck');
        if (this.placeholder) {
          this.placeholder.remove();
          this.placeholder = null;
        }
      }

      if (this.mode === 'scroll-up') {
        const goingDown = y > this.lastY && y > this.threshold + 120;
        this.classList.toggle('is-hidden', goingDown && !document.body.classList.contains('is-locked'));
      }
      this.lastY = y;
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    initMenus() {
      const items = this.querySelectorAll('[data-has-menu]');
      items.forEach((item) => {
        let timer;
        const open = () => {
          clearTimeout(timer);
          items.forEach((i) => i !== item && i.classList.remove('is-open'));
          item.classList.add('is-open');
          const link = item.querySelector('.header__link');
          if (link) link.setAttribute('aria-expanded', 'true');
        };
        const close = () => {
          timer = setTimeout(() => {
            item.classList.remove('is-open');
            const link = item.querySelector('.header__link');
            if (link) link.setAttribute('aria-expanded', 'false');
          }, 140);
        };
        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', close);
        item.addEventListener('focusin', open);
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) close();
        });
      });
    }
  }
  if (!customElements.get('flame-header')) customElements.define('flame-header', FlameHeader);

  /* ------------------------------------------------------------------------
     Menu mobile a fisarmonica
     ------------------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.mobile-nav__toggle');
    if (!toggle) return;
    e.preventDefault();
    const item = toggle.closest('.mobile-nav__item');
    item.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', item.classList.contains('is-open'));
  });

  /* ------------------------------------------------------------------------
     Accordion
     ------------------------------------------------------------------------ */
  class FlameAccordion extends HTMLElement {
    connectedCallback() {
      this.single = this.dataset.single === 'true';
      this.querySelectorAll('.accordion__trigger').forEach((trigger) => {
        trigger.addEventListener('click', () => this.toggle(trigger));
      });
      this.querySelectorAll('.accordion__item.is-open').forEach((item) => this.expand(item));
    }

    toggle(trigger) {
      const item = trigger.closest('.accordion__item');
      const isOpen = item.classList.contains('is-open');
      if (this.single) {
        this.querySelectorAll('.accordion__item.is-open').forEach((other) => {
          if (other !== item) this.collapse(other);
        });
      }
      isOpen ? this.collapse(item) : this.expand(item);
    }

    expand(item) {
      const panel = item.querySelector('.accordion__panel');
      const trigger = item.querySelector('.accordion__trigger');
      item.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        panel.addEventListener(
          'transitionend',
          () => {
            if (item.classList.contains('is-open')) panel.style.maxHeight = 'none';
          },
          { once: true }
        );
      }
    }

    collapse(item) {
      const panel = item.querySelector('.accordion__panel');
      const trigger = item.querySelector('.accordion__trigger');
      if (panel) {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        requestAnimationFrame(() => {
          panel.style.maxHeight = '0px';
        });
      }
      item.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  }
  if (!customElements.get('flame-accordion')) customElements.define('flame-accordion', FlameAccordion);

  /* ------------------------------------------------------------------------
     Slider orizzontale
     ------------------------------------------------------------------------ */
  class FlameSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.slider');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.prev = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');
      this.dots = this.querySelectorAll('[data-slider-dot]');
      this.progress = this.querySelector('.slider-progress__bar');

      if (this.prev) this.prev.addEventListener('click', () => this.scrollBy(-1));
      if (this.next) this.next.addEventListener('click', () => this.scrollBy(1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

      this.track.addEventListener('scroll', debounce(() => this.update(), 60), { passive: true });
      window.addEventListener('resize', debounce(() => this.update(), 200));
      this.update();

      if (this.dataset.autoplay === 'true') {
        const delay = parseInt(this.dataset.autoplaySpeed || '5000', 10);
        this.timer = setInterval(() => {
          const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
          atEnd ? this.goTo(0) : this.scrollBy(1);
        }, delay);
        this.addEventListener('mouseenter', () => clearInterval(this.timer));
      }
    }

    get step() {
      const slide = this.slides[0];
      if (!slide) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
      return slide.offsetWidth + gap;
    }

    scrollBy(dir) {
      this.track.scrollBy({ left: this.step * dir, behavior: 'smooth' });
    }

    goTo(index) {
      this.track.scrollTo({ left: this.step * index, behavior: 'smooth' });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const atStart = scrollLeft <= 2;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;
      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;

      const index = Math.round(scrollLeft / this.step);
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));

      if (this.progress) {
        const ratio = clientWidth / scrollWidth;
        this.progress.style.width = `${ratio * 100}%`;
        this.progress.style.left = `${(scrollLeft / scrollWidth) * 100}%`;
      }
    }
  }
  if (!customElements.get('flame-slider')) customElements.define('flame-slider', FlameSlider);

  /* ------------------------------------------------------------------------
     Animazioni allo scroll
     ------------------------------------------------------------------------ */
  const initAnimations = (root = document) => {
    if (document.body.classList.contains('no-animations')) return;
    const targets = root.querySelectorAll('[data-animate]:not(.is-visible)');
    if (!targets.length || !('IntersectionObserver' in window)) {
      targets.forEach((t) => t.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    targets.forEach((t) => io.observe(t));
  };
  Flame.initAnimations = initAnimations;

  /* ------------------------------------------------------------------------
     Quantità
     ------------------------------------------------------------------------ */
  class FlameQuantity extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.quantity__input');
      this.querySelectorAll('.quantity__button').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const dir = btn.dataset.qty === 'plus' ? 1 : -1;
          const min = parseInt(this.input.min || '1', 10);
          const max = this.input.max ? parseInt(this.input.max, 10) : Infinity;
          const next = Math.min(max, Math.max(min, parseInt(this.input.value || '1', 10) + dir));
          if (next === parseInt(this.input.value, 10)) return;
          this.input.value = next;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }
  if (!customElements.get('flame-quantity')) customElements.define('flame-quantity', FlameQuantity);

  /* ------------------------------------------------------------------------
     Carrello
     ------------------------------------------------------------------------ */
  const Cart = {
    async get() {
      const res = await fetch(`${Flame.routes.cart || '/cart'}.js`, {
        headers: { 'Content-Type': 'application/json' }
      });
      return res.json();
    },

    async add(items, extra = {}) {
      const body = {
        items: Array.isArray(items) ? items : [items],
        sections: 'cart-drawer',
        sections_url: window.location.pathname,
        ...extra
      };
      const res = await fetch(`${Flame.routes.cartAdd || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) throw data;
      await this.refresh(data);
      return data;
    },

    async change(payload) {
      const res = await fetch(`${Flame.routes.cartChange || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...payload, sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw data;
      await this.refresh(data);
      return data;
    },

    async refresh(data) {
      let cart = data;
      if (!cart || typeof cart.item_count === 'undefined') cart = await this.get();

      // Aggiorna il contatore nell'header
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });

      // Contatore del tema Horizon (pastiglia sull'icona carrello)
      document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle('hidden', cart.item_count === 0);
      });
      document.querySelectorAll('.cart-bubble').forEach((el) => {
        el.classList.toggle('visually-hidden', cart.item_count === 0);
      });

      // Rigenera il cart drawer tramite Section Rendering API
      const markup = data && data.sections && data.sections['cart-drawer'];
      if (markup) {
        this.replaceDrawer(markup);
      } else {
        const res = await fetch(`${window.location.pathname}?sections=cart-drawer`);
        const json = await res.json();
        if (json['cart-drawer']) this.replaceDrawer(json['cart-drawer']);
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart }, bubbles: true }));
      // Compatibilità con app di terze parti (upsell, bundle, cart drawer esterni)
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (window.Shopify && window.Shopify.onCartUpdate) window.Shopify.onCartUpdate(cart);
    },

    replaceDrawer(markup) {
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const fresh = parsed.querySelector('#cart-drawer');
      const current = document.querySelector('#cart-drawer');
      if (!fresh || !current) return;
      const wasOpen = current.classList.contains('is-open');
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) current.classList.add('is-open');
      initAnimations(current);
    }
  };
  Flame.Cart = Cart;

  /* Aggiunta al carrello (pagina prodotto, quick add, bundle) */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.submitBtn = this.querySelector('[name="add"]');
      this.errorEl = this.querySelector('[data-form-error]');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    async onSubmit(e) {
      // Se un'app (bundle/upsell) ha preso il controllo del form, non interferiamo.
      if (this.dataset.ajax === 'false' || this.form.dataset.appControlled === 'true') return;
      e.preventDefault();
      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      this.setLoading(true);
      if (this.errorEl) this.errorEl.hidden = true;

      try {
        const formData = new FormData(this.form);
        const body = {};
        formData.forEach((value, key) => {
          if (key === 'sections' || key === 'sections_url') return;
          if (key.startsWith('properties[')) {
            body.properties = body.properties || {};
            body.properties[key.slice(11, -1)] = value;
          } else {
            body[key] = value;
          }
        });
        await Cart.add(body);
        if (Flame.settings.cartType === 'page') {
          window.location.href = Flame.routes.cart || '/cart';
        } else if (flameOwnDrawer()) {
          openDrawer('cart-drawer', this.submitBtn);
        } else {
          this.showAdded();
        }
      } catch (err) {
        if (this.errorEl) {
          this.errorEl.textContent = (err && (err.description || err.message)) || Flame.strings.cartError;
          this.errorEl.hidden = false;
        }
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(state) {
      if (!this.submitBtn) return;
      this.submitBtn.classList.toggle('is-loading', state);
      this.submitBtn.setAttribute('aria-disabled', state);
      const label = this.submitBtn.querySelector('[data-btn-label]');
      if (label) {
        if (state) {
          this.submitBtn.dataset.prevLabel = label.textContent;
          label.textContent = Flame.strings.adding || 'Aggiungo…';
        } else if (this.submitBtn.dataset.prevLabel) {
          label.textContent = this.submitBtn.dataset.prevLabel;
        }
      }
    }

    showAdded() {
      const label = this.submitBtn.querySelector('[data-btn-label]');
      if (!label) return;
      const prev = label.textContent;
      label.textContent = Flame.strings.added || 'Aggiunto';
      setTimeout(() => {
        label.textContent = prev;
      }, 1800);
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  /* Righe del carrello */
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-cart-quantity]');
    if (!input) return;
    const line = input.dataset.line;
    const item = input.closest('.cart-item');
    if (item) item.classList.add('is-loading');
    try {
      await Cart.change({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) });
    } catch (err) {
      console.error(err);
    }
  });

  document.addEventListener('click', async (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    const item = remove.closest('.cart-item');
    if (item) item.classList.add('is-loading');
    try {
      await Cart.change({ line: parseInt(remove.dataset.line, 10), quantity: 0 });
    } catch (err) {
      console.error(err);
    }
  });

  /* Quick add dalle schede prodotto */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.quickAdd;
    if (!variantId) return;
    btn.classList.add('is-loading');
    try {
      await Cart.add({ id: variantId, quantity: 1 });
      afterAddToCart(btn);
    } catch (err) {
      console.error(err);
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  /* ------------------------------------------------------------------------
     Selettore varianti
     ------------------------------------------------------------------------ */
  class VariantSelects extends HTMLElement {
    connectedCallback() {
      this.productId = this.dataset.product;
      this.sectionId = this.dataset.section;
      this.url = this.dataset.url;
      this.variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      this.addEventListener('change', this.onChange.bind(this));
    }

    get selectedOptions() {
      return Array.from(this.querySelectorAll('input:checked, select')).map((el) => el.value);
    }

    onChange() {
      const options = this.selectedOptions;
      const variant = this.variants.find((v) =>
        v.options.every((opt, i) => opt === options[i])
      );

      this.updateLabels(options);

      if (!variant) {
        this.setUnavailable();
        return;
      }

      this.currentVariant = variant;
      this.updateUrl(variant);
      this.updateFormId(variant);
      this.updatePrice(variant);
      this.updateMedia(variant);
      this.updateButton(variant);

      document.dispatchEvent(
        new CustomEvent('variant:changed', { detail: { variant, sectionId: this.sectionId }, bubbles: true })
      );
    }

    updateLabels(options) {
      this.querySelectorAll('[data-option-value]').forEach((el) => {
        const idx = parseInt(el.dataset.optionValue, 10);
        if (options[idx] !== undefined) el.textContent = options[idx];
      });
    }

    updateUrl(variant) {
      if (!variant || !this.url) return;
      window.history.replaceState({}, '', `${this.url}?variant=${variant.id}`);
    }

    updateFormId(variant) {
      document
        .querySelectorAll(`[data-variant-input="${this.sectionId}"], .product-form input[name="id"]`)
        .forEach((input) => {
          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePrice(variant) {
      const container = document.querySelector(`[data-price-wrapper="${this.sectionId}"]`);
      if (!container) return;
      const regular = container.querySelector('.price__regular');
      const compare = container.querySelector('.price__compare');
      if (regular) regular.textContent = formatMoney(variant.price);
      if (compare) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        compare.hidden = !onSale;
        container.classList.toggle('price--on-sale', !!onSale);
      }
    }

    updateMedia(variant) {
      if (!variant.featured_media) return;
      const gallery = document.querySelector(`[data-gallery="${this.sectionId}"]`);
      if (!gallery) return;
      const target = gallery.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      if (!target) return;
      if (gallery.dataset.layout === 'stacked') {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        gallery.prepend(target);
      }
    }

    updateButton(variant) {
      const btn = document.querySelector(`[data-add-button="${this.sectionId}"]`);
      if (!btn) return;
      const label = btn.querySelector('[data-btn-label]');
      btn.disabled = !variant.available;
      btn.setAttribute('aria-disabled', !variant.available);
      if (label) {
        label.textContent = variant.available
          ? Flame.strings.addToCart || 'Aggiungi al carrello'
          : Flame.strings.soldOut || 'Esaurito';
      }
    }

    setUnavailable() {
      const btn = document.querySelector(`[data-add-button="${this.sectionId}"]`);
      if (!btn) return;
      const label = btn.querySelector('[data-btn-label]');
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      if (label) label.textContent = Flame.strings.unavailable || 'Non disponibile';
    }
  }
  if (!customElements.get('variant-selects')) customElements.define('variant-selects', VariantSelects);

  /* ------------------------------------------------------------------------
     Barra acquisto fissa
     ------------------------------------------------------------------------ */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.reference = document.querySelector('[data-sticky-reference]');
      if (!this.reference || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        },
        { threshold: 0 }
      );
      this.observer.observe(this.reference);

      this.querySelectorAll('[data-sticky-submit]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const form = document.querySelector('product-form form');
          if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      });

      document.addEventListener('variant:changed', (e) => {
        const price = this.querySelector('[data-sticky-price]');
        if (price) price.textContent = formatMoney(e.detail.variant.price);
      });
    }
  }
  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);

  /* ------------------------------------------------------------------------
     Galleria prodotto
     ------------------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    e.preventDefault();
    const gallery = document.querySelector(`[data-gallery="${thumb.dataset.section}"]`);
    if (!gallery) return;
    const target = gallery.querySelector(`[data-media-id="${thumb.dataset.thumb}"]`);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    thumb.parentNode.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  });

  /* ------------------------------------------------------------------------
     Lightbox
     ------------------------------------------------------------------------ */
  const Lightbox = {
    init() {
      this.el = document.querySelector('[data-lightbox]');
      if (!this.el) return;
      this.img = this.el.querySelector('img');
      this.items = [];
      this.index = 0;

      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-lightbox-open]');
        if (trigger) {
          e.preventDefault();
          const group = trigger.closest('[data-lightbox-group]') || document;
          this.items = Array.from(group.querySelectorAll('[data-lightbox-open]'));
          this.index = this.items.indexOf(trigger);
          this.open();
        }
        if (e.target.closest('[data-lightbox-close]') || e.target === this.el) this.close();
        if (e.target.closest('[data-lightbox-prev]')) this.move(-1);
        if (e.target.closest('[data-lightbox-next]')) this.move(1);
      });

      document.addEventListener('keydown', (e) => {
        if (!this.el.classList.contains('is-open')) return;
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.move(-1);
        if (e.key === 'ArrowRight') this.move(1);
      });
    },
    open() {
      this.render();
      this.el.classList.add('is-open');
      lockScroll();
    },
    close() {
      this.el.classList.remove('is-open');
      unlockScroll();
    },
    move(dir) {
      this.index = (this.index + dir + this.items.length) % this.items.length;
      this.render();
    },
    render() {
      const item = this.items[this.index];
      if (!item || !this.img) return;
      this.img.src = item.dataset.lightboxOpen;
      this.img.alt = item.dataset.lightboxAlt || '';
    }
  };

  /* ------------------------------------------------------------------------
     Barra annunci a rotazione
     ------------------------------------------------------------------------ */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.announcement__slide'));
      if (this.slides.length < 2) return;
      this.index = 0;
      const speed = parseInt(this.dataset.speed || '5000', 10);
      this.querySelectorAll('[data-announcement-prev]').forEach((b) =>
        b.addEventListener('click', () => this.go(-1))
      );
      this.querySelectorAll('[data-announcement-next]').forEach((b) =>
        b.addEventListener('click', () => this.go(1))
      );
      if (this.dataset.autoplay === 'true') {
        this.timer = setInterval(() => this.go(1), speed);
      }
    }
    go(dir) {
      this.slides[this.index].classList.remove('is-active');
      this.index = (this.index + dir + this.slides.length) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
    }
  }
  if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);

  /* ------------------------------------------------------------------------
     Ricerca predittiva
     ------------------------------------------------------------------------ */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-search-results]');
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', debounce(() => this.search(), 300));
    }

    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) {
        this.results.innerHTML = '';
        return;
      }
      this.results.classList.add('is-loading');
      const types = this.dataset.types || 'product';
      try {
        const url = `${Flame.routes.predictiveSearch || '/search/suggest'}?q=${encodeURIComponent(
          q
        )}&resources[type]=${types}&resources[limit]=6&section_id=predictive-search`;
        const res = await fetch(url);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fresh = doc.querySelector('[data-search-results]');
        this.results.innerHTML = fresh ? fresh.innerHTML : '';
      } catch (err) {
        console.error(err);
      } finally {
        this.results.classList.remove('is-loading');
      }
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);

  /* ------------------------------------------------------------------------
     Filtri collezione
     ------------------------------------------------------------------------ */
  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.addEventListener('change', debounce(() => this.apply(), 350));
      this.querySelectorAll('.facet__trigger').forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const facet = trigger.closest('.facet');
          const wasOpen = facet.classList.contains('is-open');
          this.querySelectorAll('.facet.is-open').forEach((f) => f.classList.remove('is-open'));
          facet.classList.toggle('is-open', !wasOpen);
        });
      });
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.facet')) {
          this.querySelectorAll('.facet.is-open').forEach((f) => f.classList.remove('is-open'));
        }
      });
      this.querySelectorAll('[data-facet-remove]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.load(btn.getAttribute('href'));
        });
      });
    }

    apply() {
      if (!this.form) return;
      const params = new URLSearchParams(new FormData(this.form)).toString();
      this.load(`${window.location.pathname}?${params}`);
    }

    async load(url) {
      const grid = document.querySelector('[data-collection-grid]');
      if (grid) grid.classList.add('is-loading');
      try {
        const res = await fetch(url);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        ['[data-collection-grid]', '[data-facets]', '[data-collection-count]'].forEach((sel) => {
          const fresh = doc.querySelector(sel);
          const current = document.querySelector(sel);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
        window.history.pushState({}, '', url);
        initAnimations(document.querySelector('[data-collection-grid]') || document);
      } catch (err) {
        console.error(err);
      } finally {
        if (grid) grid.classList.remove('is-loading');
      }
    }
  }
  if (!customElements.get('facet-filters')) customElements.define('facet-filters', FacetFilters);

  /* ------------------------------------------------------------------------
     Bundle builder
     ------------------------------------------------------------------------ */
  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      this.tiers = JSON.parse(this.dataset.tiers || '[]');
      const tierQty = this.tiers.map((t) => parseInt(t.quantity, 10)).filter((n) => !isNaN(n));
      const declared = parseInt(this.dataset.size || '3', 10);
      // massimo di candele selezionabili: il più alto tra l'impostazione e i livelli
      this.size = tierQty.length ? Math.max(declared, ...tierQty) : declared;
      // minimo per poter aggiungere il set: il livello più basso
      const declaredMin = parseInt(this.dataset.min || '0', 10);
      this.min = declaredMin > 0 ? declaredMin : (tierQty.length ? Math.min(...tierQty) : this.size);
      this.selection = [];
      this.items = Array.from(this.querySelectorAll('.bundle-item'));
      this.slots = Array.from(this.querySelectorAll('.bundle__slot'));
      this.submit = this.querySelector('[data-bundle-submit]');
      this.totalEl = this.querySelector('[data-bundle-total]');
      this.compareEl = this.querySelector('[data-bundle-compare]');
      this.countEl = this.querySelector('[data-bundle-count]');

      this.items.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggle(item);
        });
      });

      if (this.submit) this.submit.addEventListener('click', () => this.addToCart());
      this.render();
    }

    toggle(item) {
      const id = item.dataset.variantId;
      if (!id) return;
      const idx = this.selection.findIndex((s) => s.id === id);
      if (idx > -1) {
        this.selection.splice(idx, 1);
      } else {
        if (this.selection.length >= this.size) return;
        this.selection.push({
          id,
          price: parseInt(item.dataset.price || '0', 10),
          image: item.dataset.image || '',
          title: item.dataset.title || ''
        });
      }
      this.render();
    }

    get activeTier() {
      let active = null;
      this.tiers.forEach((tier) => {
        if (this.selection.length >= tier.quantity) active = tier;
      });
      return active;
    }

    render() {
      const ids = this.selection.map((s) => s.id);
      this.items.forEach((item) => {
        const selected = ids.includes(item.dataset.variantId);
        item.classList.toggle('is-selected', selected);
        item.classList.toggle('is-disabled', !selected && this.selection.length >= this.size);
      });

      this.slots.forEach((slot, i) => {
        const sel = this.selection[i];
        slot.classList.toggle('is-filled', !!sel);
        slot.innerHTML = sel
          ? `<img src="${sel.image}" alt="${sel.title}">`
          : `<span>${i + 1}</span>`;
      });

      const subtotal = this.selection.reduce((sum, s) => sum + s.price, 0);
      const tier = this.activeTier;
      const discount = tier ? tier.discount : 0;
      const total = Math.round(subtotal * (1 - discount / 100));

      if (this.totalEl) this.totalEl.textContent = formatMoney(total);
      if (this.compareEl) {
        this.compareEl.textContent = discount > 0 ? formatMoney(subtotal) : '';
        this.compareEl.hidden = discount === 0;
      }
      if (this.countEl) this.countEl.textContent = `${this.selection.length}/${this.size}`;

      this.querySelectorAll('.bundle__tier').forEach((el) => {
        el.classList.toggle('is-active', tier && parseInt(el.dataset.qty, 10) === tier.quantity);
      });

      if (this.submit) {
        const ready = this.selection.length >= this.min;
        this.submit.disabled = !ready;
        this.submit.classList.toggle('is-disabled', !ready);
      }
    }

    async addToCart() {
      if (this.selection.length < this.min) return;
      this.submit.classList.add('is-loading');
      const bundleName = this.dataset.bundleName || 'Set Flamè';
      const items = this.selection.map((s) => ({
        id: s.id,
        quantity: 1,
        properties: { _bundle: bundleName }
      }));
      try {
        await Cart.add(items);
        const tier = this.activeTier;
        const code = tier && tier.code ? tier.code : '';
        if (code) {
          // Applica il codice sconto e torna al carrello
          window.location.href = `${Flame.routes.root || ''}/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(
            Flame.routes.cart || '/cart'
          )}`;
          return;
        }
        afterAddToCart(this.submit);
      } catch (err) {
        console.error(err);
      } finally {
        this.submit.classList.remove('is-loading');
      }
    }
  }
  if (!customElements.get('bundle-builder')) customElements.define('bundle-builder', BundleBuilder);

  /* ------------------------------------------------------------------------
     Prodotti consigliati (API suggerimenti di Shopify)
     ------------------------------------------------------------------------ */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      const load = () => {
        fetch(url)
          .then((res) => res.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim().length) {
              this.innerHTML = fresh.innerHTML;
              initAnimations(this);
              initMarquee(this);
            } else {
              const section = this.closest('.shopify-section');
              if (section) section.style.display = 'none';
            }
          })
          .catch(() => {});
      };

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            load();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        io.observe(this);
      } else {
        load();
      }
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  /* Prodotti complementari nella colonna informazioni del prodotto */
  const initComplementary = (root = document) => {
    root.querySelectorAll('[data-complementary]:not([data-loaded])').forEach((el) => {
      const url = el.dataset.url;
      if (!url) return;
      el.setAttribute('data-loaded', 'true');
      fetch(url)
        .then((res) => res.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('[data-complementary]');
          if (fresh && fresh.innerHTML.trim().length) {
            el.innerHTML = fresh.innerHTML;
          } else {
            el.remove();
          }
        })
        .catch(() => {});
    });
  };

  /* ------------------------------------------------------------------------
     Video con click-to-play
     ------------------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const play = e.target.closest('.video-play');
    if (!play) return;
    const wrapper = play.closest('[data-video-wrapper]');
    if (!wrapper) return;
    const video = wrapper.querySelector('video');
    const iframe = wrapper.querySelector('iframe');
    if (video) {
      video.controls = true;
      video.play();
    } else if (iframe) {
      const src = iframe.dataset.src || iframe.src;
      iframe.src = src.includes('?') ? `${src}&autoplay=1` : `${src}?autoplay=1`;
    }
    play.classList.add('is-hidden');
  });

  /* Pausa dei video di sfondo fuori dallo schermo (performance) */
  const initBackgroundVideos = () => {
    if (!('IntersectionObserver' in window)) return;
    const videos = document.querySelectorAll('video[data-bg-video]');
    if (!videos.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const v = entry.target;
          if (entry.isIntersecting) {
            if (v.paused) v.play().catch(() => {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      },
      { threshold: 0.1 }
    );
    videos.forEach((v) => io.observe(v));
  };

  /* ------------------------------------------------------------------------
     Torna su
     ------------------------------------------------------------------------ */
  const initBackToTop = () => {
    const btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    window.addEventListener(
      'scroll',
      () => btn.classList.toggle('is-visible', window.scrollY > window.innerHeight),
      { passive: true }
    );
  };

  /* ------------------------------------------------------------------------
     Marquee — duplica il contenuto per uno scorrimento continuo
     ------------------------------------------------------------------------ */
  const initMarquee = (root = document) => {
    root.querySelectorAll('.marquee:not([data-ready])').forEach((marquee) => {
      const track = marquee.querySelector('.marquee__track');
      if (!track) return;
      const clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      marquee.appendChild(clone);
      marquee.setAttribute('data-ready', 'true');
    });
  };

  /* ------------------------------------------------------------------------
     Avvio
     ------------------------------------------------------------------------ */
  const init = (root = document) => {
    initAnimations(root);
    initMarquee(root);
    initBackgroundVideos();
    initComplementary(root);
  };

  document.addEventListener('DOMContentLoaded', () => {
    init();
    Lightbox.init();
    initBackToTop();
  });

  /* Ricarica i comportamenti quando il customizer ricarica una sezione */
  document.addEventListener('shopify:section:load', (e) => {
    init(e.target);
  });
  document.addEventListener('shopify:section:select', (e) => {
    const drawer = e.target.querySelector('flame-drawer');
    if (drawer) drawer.open();
  });
  document.addEventListener('shopify:block:select', (e) => {
    const slider = e.target.closest('flame-slider');
    if (slider && typeof slider.goTo === 'function') {
      const index = Array.from(e.target.parentNode.children).indexOf(e.target);
      slider.goTo(index);
    }
  });
})();

(function(){function reveal(){try{document.querySelectorAll('.flame-section [data-animate]').forEach(function(el){var r=el.getBoundingClientRect();if(r.top<window.innerHeight+200){el.classList.add('is-visible');}});}catch(e){}}
if(document.readyState==='complete'){setTimeout(reveal,600);}else{window.addEventListener('load',function(){setTimeout(reveal,600);});}
setTimeout(function(){try{document.querySelectorAll('.flame-section [data-animate]:not(.is-visible)').forEach(function(el){var r=el.getBoundingClientRect();if(r.top<window.innerHeight){el.classList.add('is-visible');}});}catch(e){}},2500);})();